import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormLabel,
  HStack,
  Input,
  Stack,
  Text,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import MainInput from "../../../../components/Form/input";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { openQuestionsListModel } from "../../../../modules/admin-modules/models/Actions";
import { getAllTagsRequest } from "../../../../modules/admin-modules/tags/Actions";

const StepTwo = ({
  watchTotalQustions,
  watchSubType,
  watchQuestionWay,
  data,
  setValue,
  register,
  errors,
  isFormOne,
  watchChapters,
  watchExamTags,
  isAdd,
  watchType,
}) => {
  const dispatch = useDispatch();
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const [fieldsCount, setFieldsCount] = useState(1);
  const [tagFieldsCount, setTagFieldsCount] = useState(1);

  const chapters = useSelector((state) => state.chapters.chapters);
  const tags = useSelector((state) => state.adminTags.tags);

  useEffect(() => {
    if (tags?.length === 0) dispatch(getAllTagsRequest());
  }, [dispatch, tags?.length]);

  useEffect(() => {
    if (watchSubType == 4) {
      setValue("chapters[1][no_of_questions]", 0);
    }
  }, [watchSubType, setValue]);
  const groups = useSelector((state) => state.groups.groups);
  const performanceGroups = useSelector(
    (state) => state.groups.performanceGroups
  );

  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const performanceGroupsOptions =
    performanceGroups?.length > 0
      ? performanceGroups?.map((data) => {
        return { value: data.id, label: data.name };
      })
      : [];

  const chaptersOptions = chapters?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const tagsOptions = tags?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const totalSelectedQuestions = watchChapters?.reduce((accumulator, value) => {
    return Number(accumulator) + Number(value?.no_of_questions);
  }, 0);

  const totalSelectedTagQuestions = watchExamTags?.reduce(
    (accumulator, value) => {
      return Number(accumulator) + Number(value?.question_number);
    },
    0
  );
  return (
    <VStack
      display={!isFormOne ? "flex" : "none"}
      dir="ltr"
      w="100%"
      flexWrap="wrap"
      justifyContent="space-between"
      spacing="50px"
    >
      <HStack w="100%" gap={5} mt={4}>
        <Box w="45%">
          <FormLabel>Groups:</FormLabel>
          <Select
            options={groupsOptions}
            isMulti={true}
            onChange={(data) => {
              const selectedGroups = data.map((val) => val.value);
              setValue("groups", selectedGroups);
            }}
            styles={colourStyles}
            placeholder="Select groups"
            defaultValue={data?.groups?.map((val) => {
              return { label: val?.name, value: val?.id };
            })}
          />
        </Box>
        <Box w="45%">
          {performanceGroupsOptions?.map((data, index) => {
            return (
              <>
                <FormLabel>{data?.label}</FormLabel>
                <MainInput
                  label=""
                  defaultValues={data.question_number}
                  error={errors?.question_number?.message}
                  placeholder="Enter minimum target"
                  register={register}
                  name="question_number"
                  required={false}
                  onChange={(e) => {
                    setValue(
                      `chapters[${index + 1}][min_target]`,
                      e?.target?.value
                    );
                    setValue(
                      `chapters[${index + 1}][performance_gp_id]`,
                      data?.id
                    );
                  }}
                />
              </>
            );
          })}
        </Box>
      </HStack>
      <Box w="100%">
        <FormLabel>Question selection:</FormLabel>

        <Stack
          direction="row"
          role="group"
          aria-labelledby="my-radio-group"
          spacing="30px"
        >
          <label>
            <input
              {...register("random", { required: "This field is required" })}
              type="radio"
              value="0"
              defaultChecked={data?.random == 0 ? true : false}
            />
            Teacher selects questions
          </label>
          <label>
            <input
              {...register("random", { required: "This field is required" })}
              type="radio"
              value="1"
              defaultChecked={data?.random == 1 ? true : false}
            />
            Random questions from question bank
          </label>
          <Text color="red">{errors?.random?.message}</Text>
        </Stack>
      </Box>
      <HStack w="100%" alignItems="flex-start">
        <VStack w="50%" alignItems="flex-start">
          <FormLabel>Scope:</FormLabel>
          <Stack
            direction="row"
            role="group"
            aria-labelledby="my-radio-group"
            spacing="30px"
          >
            <label>
              <input
                {...register("sub_type", {
                  required: "This field is required",
                })}
                type="radio"
                value="1"
                defaultChecked={data?.sub_type == 1 ? true : false}
              />
              Single chapter
            </label>
            <label>
              <input
                {...register("sub_type", {
                  required: "This field is required",
                })}
                type="radio"
                value="2"
                disabled={watchQuestionWay == 0 ? true : false}
                defaultChecked={data?.sub_type == 2 ? true : false}
              />
              Multiple chapters (comprehensive)
            </label>
            <label>
              <input
                {...register("sub_type", {
                  required: "This field is required",
                })}
                type="radio"
                value="4"
                disabled={watchQuestionWay == 0 ? true : false}
                defaultChecked={data?.sub_type == 4 ? true : false}
              />
              Exam from tags
            </label>
          </Stack>
        </VStack>
        <Box w="50%">
          <FormLabel w="30%">Number of questions:</FormLabel>
          <MainInput
            label=""
            defaultValues={data.question_number}
            error={errors?.question_number?.message}
            placeholder="Enter number of questions"
            register={register}
            name="question_number"
            required={false}
          />
        </Box>
        {!isAdd && watchQuestionWay == 0 && (
          <Button w="30%" onClick={() => dispatch(openQuestionsListModel())}>
            Choose questions
          </Button>
        )}
      </HStack>

      {watchSubType == 1 && (
        <HStack w="100%" gap="30px" alignItems="flex-end">
          <Box w="70%">
            <FormLabel>Chapter:</FormLabel>
            <Select
              options={chaptersOptions}
              isMulti={false}
              onChange={(data) => {
                setValue("chapters[1][chapter_id]", data?.value);
                setValue("chapters[1][no_of_questions]", watchTotalQustions);
              }}
              styles={colourStyles}
              placeholder="Select chapter"
              defaultValue={data?.chapters?.map((val) => {
                return { label: val?.name, value: val?.id };
              })}
            />
          </Box>
        </HStack>
      )}
      {watchSubType == 2 && watchTotalQustions && (
        <HStack w="100%" alignItems="flex-start">
          <VStack w="70%" alignItems="flex-start">
            <FormLabel>Chapters:</FormLabel>

            {[...Array(fieldsCount)].map((val, index) => {
              return (
                <HStack w="100%" spacing="40px">
                  <Box w="45%">
                    <Select
                      options={chaptersOptions}
                      isMulti={false}
                      onChange={(data) => {
                        setValue(
                          `chapters[${index + 1}][chapter_id]`,
                          data?.value
                        );
                      }}
                      styles={colourStyles}
                      placeholder="Select chapter"
                      defaultValue={data?.chapters?.map((val) => {
                        return { label: val?.name, value: val?.id };
                      })}
                    />
                  </Box>

                  <HStack w="45%">
                    <FormLabel w="60%">Questions count:</FormLabel>
                    <Input
                      size="md"
                      defaultValues={data.question_number}
                      error={errors?.question_number?.message}
                      onChange={(e) => {
                        setValue(
                          `chapters[${index + 1}][no_of_questions]`,
                          e.target.value
                        );
                      }}
                      placeholder="Enter questions count"
                      name="question_number"
                    />
                  </HStack>
                </HStack>
              );
            })}
          </VStack>
          <Button
            w="30%"
            onClick={() => setFieldsCount((s) => s + 1)}
            isDisabled={
              totalSelectedQuestions >= watchTotalQustions ? true : false
            }
          >
            Add another chapter
          </Button>
        </HStack>
      )}
      {watchSubType == 4 && watchTotalQustions && (
        <VStack w="100%" alignItems="flex-start" spacing="30px">
          <Box w="70%">
            <FormLabel>Chapter:</FormLabel>
            <Select
              options={chaptersOptions}
              isMulti={false}
              onChange={(data) => {
                setValue("chapters[1][chapter_id]", data?.value);
                setValue("chapters[1][no_of_questions]", 0);
              }}
              styles={colourStyles}
              placeholder="Select chapter"
              defaultValue={
                data?.chapters?.[0]
                  ? {
                      label:
                        data.chapters[0]?.name ??
                        data.chapters[0]?.chapter?.name,
                      value:
                        data.chapters[0]?.id ?? data.chapters[0]?.chapter_id,
                    }
                  : undefined
              }
            />
          </Box>
          <HStack w="100%" alignItems="flex-start">
            <VStack w="70%" alignItems="flex-start">
              <FormLabel>Tags:</FormLabel>

            {[...Array(tagFieldsCount)].map((val, index) => {
              const examTag =
                data?.exam_tags?.[index] ?? data?.exam_tags?.[index + 1];
              return (
                <HStack w="100%" spacing="40px" key={index}>
                  <Box w="45%">
                    <Select
                      options={tagsOptions}
                      isMulti={false}
                      onChange={(data) => {
                        setValue(
                          `exam_tags[${index + 1}][question_tag_id]`,
                          data?.value
                        );
                      }}
                      styles={colourStyles}
                      placeholder="Select tag"
                      defaultValue={
                        examTag
                          ? {
                              label: examTag?.name ?? examTag?.tag?.name,
                              value:
                                examTag?.question_tag_id ??
                                examTag?.tag_id ??
                                examTag?.id,
                            }
                          : undefined
                      }
                    />
                  </Box>

                  <HStack w="45%">
                    <FormLabel w="60%">Questions count:</FormLabel>
                    <Input
                      size="md"
                      defaultValue={
                        examTag?.question_number ?? examTag?.no_of_questions
                      }
                      onChange={(e) => {
                        setValue(
                          `exam_tags[${index + 1}][question_number]`,
                          e.target.value
                        );
                      }}
                      placeholder="Enter questions count"
                      name="tag_question_number"
                    />
                  </HStack>
                </HStack>
              );
            })}
          </VStack>
          <Button
            w="30%"
            onClick={() => setTagFieldsCount((s) => s + 1)}
            isDisabled={
              totalSelectedTagQuestions >= watchTotalQustions ? true : false
            }
          >
            Add another tag
          </Button>
        </HStack>
        </VStack>
      )}
    </VStack>
  );
};

export default StepTwo;
